import * as actionTypes from './actionTypes';
import axios from '../../lib/axios/axios';
import { setError } from './auth';
import { loading } from './loanApply';

export const generateAuth = auth => {
  const url =
    '/v1/banks/01/users/' +
    auth.phoneNo +
    '/custom/applications/' +
    auth.applicationId +
    '/generateAuth';
  const header = { headers: { Authorization: auth.token } };

  return dispatch => {
    dispatch(loading(true));
    axios
      .get(url, header)
      .then(res => {
        dispatch(setAccesToken(res.data.data));
        dispatch(
          verifySessionId({
            phoneNo: auth.phoneNo,
            applicationId: auth.applicationId,
            oauthToken: auth.token,
            accessToken: res.data.data.accessToken
          })
        );
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      });
  };
};

export const verifySessionId = auth => {
  const url =
    '/v1/banks/01/users/' +
    auth.phoneNo +
    '/custom/applications/' +
    auth.applicationId +
    '/verifySessionId';
  const header = { headers: { Authorization: auth.oauthToken } };
  const body = { accessToken: auth.accessToken };

  return dispatch => {
    //dispatch(loading(true))
    axios
      .post(url, body, header)
      .then(res => {
        dispatch(setVerifySessionResp(res.data.data));
        dispatch(
          cashInInquiry({
            phoneNo: auth.phoneNo,
            oauthToken: auth.oauthToken,
            applicationId: auth.applicationId,
            accessToken: auth.accessToken,
            customerAccessToken: res.data.data.customerAccessToken
          })
        );
        //dispatch(loading(false))
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        //dispatch(loading(false))
      });
  };
};

export const cashInInquiry = auth => {
  const url =
    '/v1/banks/01/users/' +
    auth.phoneNo +
    '/custom/applications/' +
    auth.applicationId +
    '/cashInInquiry';
  const header = { headers: { Authorization: auth.oauthToken } };
  const body = {
    accessToken: auth.accessToken,
    amount: '200000',
    customerAccessToken: auth.customerAccessToken
  };

  return dispatch => {
    //dispatch(loading(true))
    axios
      .post(url, body, header)
      .then(res => {
        dispatch(setCashInqResp(res.data.data));
        dispatch(loading(false));
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      });
  };
};

export const saveSessionLinkaja = param => {
  return dispatch => {
    dispatch(loading(true));
    const url =
      '/v1/banks/01/users/' +
      param.phoneNo +
      '/custom/applications/' +
      param.applicationId;
    const header = {
      headers: {
        Authorization: param.token
      }
    };
    const body = {
      applicationDetails: {
        partnerId: param.partnerId,
        sessionId: param.sessionId
      }
    };
    axios
      .put(url, body, header)
      .then(() => {
        dispatch(loading(false));
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      });
  };
};

export const enableDirectDebit = auth => {
  const url =
    '/v1/banks/01/users/' +
    auth.phoneNo +
    '/custom/applications/' +
    auth.applicationId +
    '/directDebitEnable';
  const header = { headers: { Authorization: auth.oauthToken } };

  return dispatch => {
    dispatch(loading(true));
    axios
      .post(url, header)
      .then(res => {
        dispatch(setDirectDebitRes(res.data.data));
        dispatch(loading(false));
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      });
  };
};

export const linkAjaCallback = auth => {
  const url =
    '/v1/banks/01/users/' +
    auth.phoneNo +
    '/custom/applications/' +
    auth.applicationId +
    '/linkAjaTranResultUpdate';
  const header = { headers: { Authorization: auth.oauthToken } };
  const body = {
    trxId: 'TESTDD190111144332',
    refNum: 'x506319011114424500033',
    src: 'LinkAja',
    mandateID: '10601'
  };

  return dispatch => {
    dispatch(loading(true));
    axios
      .post(url, body, header)
      .then(res => {
        if (res.data.data) {
          if (res.data.data[0].statusCode === '400')
            dispatch(setError('transaction_failed'));
        }
        dispatch(loading(false));
      })
      .catch(err => {
        if (err.response && err.response.status === '400') {
          dispatch(setError('transaction_failed'));
        } else if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      });
  };
};

export const customerReject = auth => {
  const url =
    '/v1/banks/01/users/' +
    auth.phoneNo +
    '/custom/applications/' +
    auth.applicationId +
    '/custConcernUpdate';
  const header = { headers: { Authorization: auth.oauthToken } };
  const body = { custConcernRejFlag: 'Y' };

  return dispatch => {
    dispatch(loading(true));
    axios
      .put(url, body, header)
      .then(() => {
        dispatch(loading(false));
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(loading(false));
      });
  };
};

export const setAccesToken = data => {
  return {
    type: actionTypes.SET_ACCESS_TOKEN,
    res: data,
    token: data.accessToken
  };
};

export const setVerifySessionResp = data => {
  return {
    type: actionTypes.SET_VERIFY_SESSION_RES,
    res: data,
    token: data.customerAccessToken
  };
};

export const setCashInqResp = data => {
  return {
    type: actionTypes.SET_CASH_INQUIRY_RES,
    res: data,
    id: data.sessionID
  };
};

export const setDirectDebitRes = data => {
  return {
    type: actionTypes.SET_DIRECT_DEBIT_RES,
    res: data
  };
};
